import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { LoginForm } from '@app/components/auth/LoginForm/LoginForm';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import { updateGlobalLoading } from '@app/store/slices/GlobalLoadingSlice';
import { useAppDispatch } from '@app/hooks/reduxHooks';

const LoginPage: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(updateGlobalLoading(false));
  }, [dispatch]);

  return (
    <>
      <PageTitle>{t('common.login')}</PageTitle>
      <LoginForm />
    </>
  );
};

export default LoginPage;
